export default "__VITE_ASSET__Dohh7WKt__";